module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_8.6c12d382.png";